<template>
  <div>
    <h5>Reenviar e-mail de confirmação</h5>
    <p class="login-description text-muted mt-2 mb-5">
      Problemas com o e-mail de confirmação? Verifique na caixa de span ou
      solicite o reenvio. Informe seu email no campo abaixo para receber um novo
      email de confirmação.
    </p>

    <form @submit.prevent="submit()">
      <b-form-group label="E-mail:">
        <b-form-input
          v-model="form.email"
          placeholder="E-mail"
          :state="validateState('email')"
        ></b-form-input>
        <b-form-invalid-feedback>
          <span v-if="!$v.form.email.required"
            >E-mail é um campo obrigatório.</span
          >
          <span v-if="!$v.form.email.email">E-mail inválido</span>
        </b-form-invalid-feedback>
      </b-form-group>

      <b-row class="login-actions">
        <b-col cols="auto" class="mr-auto"
          ><router-link :to="{ name: 'login' }">Voltar </router-link></b-col
        >
        <b-col cols="auto"
          ><button class="btn login-button">
            Enviar <span class="material-icons"> arrow_right_alt </span>
          </button></b-col
        >
      </b-row>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  data: () => ({
    form: {
      email: "",
    },
    error_message: "",
  }),
  validations: {
    form: {
      email: {
        required,
        email,
      },
    },
  },
  computed: {},
  methods: {
    ...mapActions("auth", ["ActionForgotPassword"]),
    async submit() {
      this.error_message = "";
      try {
        await this.ActionForgotPassword(this.form);
        this.$notifications.addNotification({
          message:
            "Você receberá um email com as instruções para recuperar a senha.",
          type: "success",
        });
        this.$router.push({ name: "login" });
      } catch (err) {
        this.$notifications.addNotification({
          message: "Erro ao recuperar senha.",
          type: "danger",
        });
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
  },
  created() {},
};
</script>

<style scoped lang="scss"></style>
